export { transformServerReadings } from './surveyByteArray';
